import { Container, Dropdown, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router";

import { AuthenticatedContent } from "@/components/AuthenticatedContent";
import { AuthNavStatus } from "@/components/AuthNavStatus";
import { BootstrapDropdownNavItem } from "@/components/BootstrapDropdownNavItem";
import { BootstrapNavLink } from "@/components/BootstrapNavLink";
import { Icon } from "@/components/Icon";
import { Logo } from "@/components/Logo";
import { ThemeSwitcher } from "@/components/ThemeSwitcher";
import { SyncStatusNavDropDown } from "./SyncStatusNavDropdown";

export const TopNav: React.FC = () => {
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid>
        <Link to="/" className="navbar-brand">
          <Logo /> <span className="d-none d-lg-inline text-uppercase front-monospace">Senti Internal Tools</span>
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <AuthenticatedContent>
              <Nav.Item>
                <BootstrapNavLink to="/estimates">
                  <Icon icon="receipt" /> Estimates
                </BootstrapNavLink>
              </Nav.Item>
              <Nav.Item>
                <BootstrapNavLink to="/orders">
                  <Icon icon="clipboard2-check" /> Orders
                </BootstrapNavLink>
              </Nav.Item>
              <Nav.Item>
                <BootstrapNavLink to="/ncrs">
                  <Icon icon="clipboard2-x" /> NCRs
                </BootstrapNavLink>
              </Nav.Item>
              <Dropdown className="nav-item">
                <Dropdown.Toggle className="nav-link" variant="link">
                  <Icon icon="patch-check" className="me-1" />
                  QMS
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <BootstrapDropdownNavItem to="/qms/vendor-assessments/">
                    <Icon icon="card-checklist" /> Vendor Assessments
                  </BootstrapDropdownNavItem>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="nav-item">
                <Dropdown.Toggle className="nav-link" variant="link">
                  <Icon icon="box-arrow-up-right" className="me-1" />
                  External Tools
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="https://senti-solutions.gitlab.io/quoting-machine/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon icon="calculator" /> Quoting Tool <Icon icon="box-arrow-up-right" />
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="https://docs.google.com/spreadsheets/d/1JuiFie1VHb-s57R-pOeAg0XOlc64RWk6cYBoZEf4atI"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon icon="pencil" /> Drawing Package Generator <Icon icon="box-arrow-up-right" />
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="mailto:mark+qbo-receipt-upload@sentisolutions.ca?subject=QBO%20Receipt%20Upload&body=Please%20follow%20these%20instructions%20to%20upload%20your%20receipt%20to%20QBO%3A%0A%0A1.%20Take%20a%20picture%20of%20your%20bill%20or%20receipt%20on%20your%20mobile%20device.%0A%20%20%20%20Note%3A%20The%20photo%27s%20file%20type%20must%20be%20a%20pdf%2C%20jpeg%2C%20jpg%2C%20gif%2C%20or%20png.%0A2.%20Make%20sure%20each%20image%20or%20file%20contains%20only%20one%20receipt.%0A3.%20Attach%20the%20image%28s%29%20to%20this%20email%20and%20sent%20it%20%28the%20recipient%20must%20be%20%22mark%2Bqbo-receipt-upload%40sentisolutions.ca%22%29%0A%20%20%20%20Note%3A%20You%20can%20send%20multiple%20receipt%20images%20in%20one%20email.%20The%20email%20attachment%27s%20file%20size%20must%20be%20between%2046KB%20to%2020%20MB."
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Icon icon="receipt" /> Email Receipt to QBO <Icon icon="box-arrow-up-right" />
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Nav.Link
                href={"https://sites.google.com/sentisolutions.ca/help-center"}
                target="_blank"
                rel="noreferrer"
              >
                <Icon icon="question-circle" /> Senti Help Center <Icon icon="box-arrow-up-right" />
              </Nav.Link>
            </AuthenticatedContent>
          </Nav>
          <hr className="d-lg-none m-0 mt-1" />
          <Nav className="ms-md-auto">
            <AuthenticatedContent>
              <SyncStatusNavDropDown className="me-1" />
            </AuthenticatedContent>
            <ThemeSwitcher className="me-1" />
            <AuthNavStatus />
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
